import { render, staticRenderFns } from "./BoxDonate.vue?vue&type=template&id=1e118375&"
var script = {}
import style0 from "./BoxDonate.vue?vue&type=style&index=0&id=1e118375&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports